import env from './env'
import getDefaultConfig from '@ivy/fts/config'

let conf = {
  ...getDefaultConfig(env), // 多个项目公用的appid等等
  apiList: [
    'chooseImage', 
    'uploadImage',
    'chooseWXPay',
    'editAddress',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'hideMenuItems',
  ],
  sentryIgnore: [
    'Java exception was raised during method invocation',
    '_isDisplayingOnScreen',
    "Can't find variable: _isDisplayingOnScreen"
  ],
}
console.log('config is: ', conf)
export default conf
